const LogManagementData = [
 
];

export default LogManagementData;
